<template>
  <div class="col-sm-6" style="padding-right: 0;">
    <vc-date-picker locale="nl-NL" v-model="filter.value" v-on:input="emitToggleEvent()" />
  </div>
</template>

<script>
export default {
  name: 'DateFilter',
  props: ['filter'],
  data: function() {
    return {
      data: ''
    };
  },
  methods: {
    emitToggleEvent() {
      this.$emit('toggle-value');
    }
  }
};
</script>

<style scoped>
.vc-text-base{
  font-size: 12px !important;
  padding: 0.25rem 0.5rem !important;
  height: 28px;
}
</style>

